import { render, staticRenderFns } from "./ChartWave.vue?vue&type=template&id=34d0dcc8&"
import script from "./ChartWave.vue?vue&type=script&lang=js&"
export * from "./ChartWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports